import { useEffect } from "react";
import { applyTheme } from "@utils/theme";
import { themeSystem } from "../constants";

/**
 * Custom hook that listens for system theme changes when user has selected "system" mode
 * @param userThemePreference - The user's current theme preference
 */
export const useSystemThemeListener = (userThemePreference?: string) => {
  useEffect(() => {
    if (userThemePreference === themeSystem) {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

      const handleSystemThemeChange = () => {
        applyTheme(themeSystem);
      };

      // Listen for changes in system theme preference
      mediaQuery.addEventListener("change", handleSystemThemeChange);

      return () => {
        mediaQuery.removeEventListener("change", handleSystemThemeChange);
      };
    }
  }, [userThemePreference]);
};
